import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/images/empty-state.png'


const _hoisted_1 = {
  key: 0,
  class: "load-more-action ion-text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "empty state"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ShipmentListItem = _resolveComponent("ShipmentListItem")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Shipments")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createVNode(_component_ion_searchbar, {
              placeholder: _ctx.$t('Scan ASN to start receiving'),
              modelValue: _ctx.queryString,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryString) = $event)),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => {_ctx.queryString = $event.target.value; _ctx.getShipments();}, ["enter"]))
            }, null, 8, ["placeholder", "modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipments, (shipment) => {
              return (_openBlock(), _createBlock(_component_ShipmentListItem, {
                key: shipment.shipmentId,
                shipment: shipment
              }, null, 8, ["shipment"]))
            }), 128)),
            (_ctx.shipments.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_ion_button, {
                    fill: "outline",
                    color: "dark",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreShipments()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.cloudDownloadOutline,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("Load more shipments")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.shipments.length && !_ctx.fetchingShipments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.showErrorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("No results found")), 1))
                    : _createCommentVNode("", true),
                  _hoisted_4,
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("There are no incoming shipments")), 1),
                  _createVNode(_component_ion_button, {
                    fill: "outline",
                    color: "dark",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshShipments()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.reload,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("Refresh")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_refresher, {
              slot: "fixed",
              onIonRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshShipments($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_refresher_content, {
                  pullingIcon: "crescent",
                  refreshingSpinner: "crescent"
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}